











































import { Component, Prop, Vue } from "vue-property-decorator";
import moment from 'moment';
import { logService } from '@/services/LogService';
import { eventService } from "@/services/EventService";
import { Sorteo } from '@/model/Sorteo';

@Component({
  components: {}
})
export default class SorteoPopup extends Vue {
  
  sorteo: any | Sorteo;
  titulo: string ="";
  numero: string ="";
  valid: boolean = false;

  fechaCelebracion: string = new Date().toISOString().substr(0, 10);

  tituloRules: any = [(v: any) => !!v || 'Campo requerido']
  numeroRules: any = [(v: any) => !!v || 'Campo requerido']
  fechaCelebracionRules: any = [(v: any) => !!v || 'Campo requerido']

  destroyed(){
    eventService.off("SorteoPopup-Open");
    eventService.off("Sorteo-DialogForm-Save");
  }

  created() {
    logService.Info("Inicio","SorteoPopup.vue - created()");
    eventService.on("SorteoPopup-Open", (obj: any) => {
      this.sorteo = obj;
      if(obj.Titulo !== ""){
        this.titulo = this.sorteo.Titulo;
        this.numero = this.sorteo.Numero;
        this.fechaCelebracion = this.sorteo.FechaCelebracion;
      }
    });

    eventService.on("Sorteo-DialogForm-Save", (obj: any) => {
      if((<any>this.$refs.formSorteo).validate()){
        this.sorteo.Titulo = this.titulo;
        this.sorteo.Numero = this.numero;
        this.sorteo.FechaCelebracion = this.fechaCelebracion;
        eventService.emit('SorteoPopup-Save',this.sorteo)

        this.titulo = "";
        this.numero = "";
        this.fechaCelebracion = new Date().toISOString().substr(0, 10);
        this.sorteo = null;
        this.valid = true;
        if(this.$refs.formSorteo !== undefined){
          (<any>this.$refs.formSorteo).reset()
        }
      }
    });
  }

  get fechaCelebracionFormatted () {
    return this.fechaCelebracion ? moment(this.fechaCelebracion).format('DD/MM/YYYY') : '';
  }
}
